import React from 'react';
import { SVGComp, PathComp } from '../../components/Svgs'


const PropertiesIcon = ({ width = '20', height = '22', viewBox = '0 0 24 24', stroke = '#212121' }) => (
<SVGComp width={width} height={height} viewBox={viewBox} fill="none" xmlns="">
<PathComp d="M10 6L7 6" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
<PathComp d="M18.5 12H17" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
<PathComp d="M14 8H21V22H14M14 22V2H3V22H14ZM6.5 16H10.5V22H6.5V16Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
</SVGComp>

);

export default PropertiesIcon;
